export const SERVICE_CALENDAR_HREF = '/advisor/dashboard/service-calendar';

// v3 is nested under the v1/v2 route so both versions can be reached in the same
// session while the flags are on. V3-22 un-nests these back to /service-calendar/*
// at cutover; until then the nesting makes the v1/v2 side-nav entry render active
// on v3 URLs, which is an accepted cosmetic cost.
export const SERVICE_CALENDAR_V3_HREF = '/advisor/dashboard/service-calendar/v3';

export const SERVICES_HREF = '/advisor/dashboard/templates/services';
export const SERVICE_NEW_HREF = '/advisor/dashboard/templates/services/new';

export function serviceEditHref(id: string): string {
  return `${SERVICES_HREF}/${encodeURIComponent(id)}`;
}
